<template>
  <div>
    <div class="form-wrap">
      <div class="form-list">

        <div class="row">

          <!-- 学校・団体リスト -->
          <div class="organization-area col-5 col-lg-4 text-center pr-0" >

            <div class="d-flex flex-column">
              <!-- 現在閲覧中 -->
              <div class="mb-3">
                <router-link v-if="viewingEvents.length > 0" tag="button" class="btn-organization btn-viewing-btn btn" :to="{ name: 'mypage::event::viewing', params: {} }" >
                  <trans-text i18nKey="ui['5_1'][5]" :isHtml="true" />
                </router-link>
              </div>

              <!-- 学校・団体 -->
              <div class="my-2" v-for="organizationYearSeparation in organizationYearSeparations">
                <h4 class="year-separation h6 mb-1"> <trans-text i18nKey="ui['5_1'][6]" :replaceData="{school_code_year:organizationYearSeparation}" :isHtml="true"/></h4>

                <div class="my-2" v-for="organization in organizationsByYearSeparation(organizationYearSeparation)">
                <router-link tag="button" class="btn-organization btn" :to="{ name: 'mypage::event::organization',params: {organization_school_code_id:organization.organization_school_code_id} }" >
                  {{organization.name}}
                </router-link>
                </div>
              </div>
            </div>
          </div>

          <!-- 販売イベントリスト -->
          <div class="event-area col-7 col-lg-8 py-4 pl-1 pr-4">
            <!-- 買い物かごへ -->
            <div class="row text-center">
              <div class="offset-sm-1 offset-lg-2 col-12 col-sm-10 col-lg-8">
                <div class="px-1">
                  <router-link tag="button" class="btn-cart btn w-100 btn-lg btn-warning" v-if="!isEmptyCartPhotos" :to="{ name: 'mypage::event::cart', query: {back_path:$route.path} }">
                    <trans-text i18nKey="ui['5_1'][7]" />
                  </router-link>
                </div>
              </div>
            </div>
            <!-- 公開中の販売イベント -->
            <div class="row">
              <div class="col-lg-6 pt-5 text-center">
                <!-- 公開中イベントヘッダー -->
                <h3 class="news-head h5 font-size-md-07-down font-size-lg-08-up mb-0">
                  <span style="position: relative; z-index: 10"><trans-text i18nKey="ui['5_1'][8]"/></span>
                  <hr class="w-100 news-head-bg-line my-0"/>
                  <hr class="h-100 news-head-bg-line-center my-0" />
                </h3>
                <!-- 公開中イベント -->
                <ul class="now-public-event-list text-center list-unstyled">
                  <li class="py-2" v-for="event in eventsByNowPublic">
                    <p class="end-at text-danger mb-0 "><trans-text i18nKey="ui['5_1'][9]" :replaceData="{datetime: event.end_at_disp}"/></p>
                    <div class="event-status text-danger mb-1 px-3">
                      <i class="event-status-mark fa fa-chevron-circle-right" aria-hidden="true"></i> <span class="badge badge-danger badge-lg"><trans-text i18nKey="ui['5_1'][10]" /></span>
                    </div>

                    <div class="text-center">
                      <router-link tag="button" class="btn-event btn btn-warning" :to="{ name: 'mypage::event::catalog', params: {event_id:event.id} }" :ref="'linkOrderCatalog'+event.id">
                        {{event.name}}
                      </router-link>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6 pt-5">
                <h3 class="news-head h5 font-size-md-07-down font-size-lg-08-up mb-0 text-center">
                  <span style="position: relative; z-index: 10"><trans-text i18nKey="ui['5_1'][11]"/></span>
                  <hr class="w-100 news-head-bg-line my-0"/>
                  <hr class="h-100 news-head-bg-line-center my-0" />
                </h3>

                <!-- 公開終了イベント -->
                <ul class="public-exit-event-list text-center list-unstyled">
                  <li class="py-2" v-for="event in eventsByNPiblicExit">
                    <p class="end-at text-default mb-0"><trans-text i18nKey="ui['5_1'][9]" :replaceData="{datetime: event.end_at_disp}"/></p>
                    <div class="event-status text-default mb-1 px-3">
                      <i class="event-status-mark fa fa-times-circle" aria-hidden="true"></i> <span class="badge badge-default badge-lg"><trans-text i18nKey="ui['5_1'][12]" /></span>
                    </div>

                    <div class="text-center">
                      <router-link tag="button" class="btn-event btn btn-default" :to="{ name: '', params: {} }">
                        {{event.name}}
                      </router-link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  export default {
    name:"",
    props:['organizations','viewingEvents','isEmptyCartPhotos'],
    components: {
    },
    data () {
      return {
          testData:'',
      }
    },
    computed:{
      organizationYearSeparations(){
        let rets = []
        app.make("_").each(this.organizations,function(organization){
          app.make("_").each(organization.organization_school_codes,function(organization_school_code) {
            rets.push(organization_school_code.year_separation)
          })
        })
        rets = app.make("_").uniq(rets)
        rets = app.make("_").sortBy(rets,elem =>{ return elem * -1})
        return rets
      },
      eventsByNowPublic(){
        let rets=[];
          switch(this.$route.name){
            case "mypage::event::viewing":
              app.make("_").each(this.viewingEvents,(event)=>{
                if(Number(event.now_status_code) !== 12){ return }
                rets.push(event)
              })
              return rets
            case "mypage::event::organization":

              app.make("_").each(this.organizations,(organization)=>{
                app.make("_").each(organization.organization_school_codes,(organization_school_code)=> {
                  app.make("_").each(organization_school_code.events,(event) =>{
                    if (!(Number(event.organization_school_code_id) === Number(this.$route.params.organization_school_code_id))) {
                        return
                    }
                    if(Number(event.now_status_code) !== 12){ return }
                    rets.push(event)
                  })
                })
              })
              return rets
          }
      },
      eventsByNPiblicExit(){
        let rets=[];
        switch(this.$route.name){
          case "mypage::event::viewing":

            app.make("_").each(this.viewingEvents,(event)=>{
              if(Number(event.now_status_code) !== 13){ return }
              rets.push(event)
            })
            return rets
            break;
          case "mypage::event::organization":
            app.make("_").each(this.organizations,(organization)=>{
              app.make("_").each(organization.organization_school_codes,(organization_school_code)=> {
                app.make("_").each(organization_school_code.events,(event) =>{
                  if (!(Number(event.organization_school_code_id) === Number(this.$route.params.organization_school_code_id))) {
                    return
                  }
                  if(Number(event.now_status_code) !== 13){ return }
                  rets.push(event)
                })
              })
            })
            return rets
        }
      }

    },

    created(){
    },

    methods:{
//      checkEventActivated(event){
//          this.$emit("checkEventActivated",event)
//      },
      organizationsByYearSeparation(yearSeparation){
        let rets = []
        app.make("_").each(this.organizations,function(organization){
          let flg=true
          let schoolCodeId = null
          app.make("_").each(organization.organization_school_codes,function(organization_school_code) {
            if(Number(organization_school_code.year_separation) === Number(yearSeparation)){ schoolCodeId=organization_school_code.id }
          })
          if(!schoolCodeId){return }

          rets.push(Object.assign({},organization, {organization_school_code_id:schoolCodeId} ))
        })
        return rets
      },
    }
  }
</script>


<style lang="scss" scoped>
  @import "~scss/_variables";

  .form-wrap{
    @media(max-width: map-get($grid-breakpoints, "md") - 1) {
      margin-top:2rem;
    }
  }
  .organization-area{
    border-right:1px solid #ccc;

    .btn-organization{
      position: relative;
      background-color: #fff;
      border: 1px solid #82b91d;
      color: #3a3939;
      font-size: .8rem;
      white-space:normal !important;
      word-wrap:break-word;
      @media(min-width: map-get($grid-breakpoints, "lg")) {
        font-size: .9rem;
      }
      width:90%;
      &.btn-viewing-btn{
        margin-top: -2rem;
      }
      &:before{
        font-family: FontAwesome;
        color:#82b91d;
        content: '\f02e';
        font-size:1rem;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(0);
        left: 2%;
      }
      &.router-link-active {
        color: #fff;
        background-color: #82ba1d;
        &:before {
          color: #fff;
        }
      }
      &:hover{
        background-color: #82ba1d;
        color: #fff;
        &:before {
          color: #fff;
        }
      }

    }
    .year-separation{
      font-size: .8rem;
      @media(min-width: map-get($grid-breakpoints, "lg")) {
        font-size: .9rem;
      }
    }
  }

  .event-area{
    .btn-cart{
      position: relative;
      @media(max-width: map-get($grid-breakpoints, "lg") - 1) {
        font-size: .8rem;
      }
      &:before{
        font-family: FontAwesome;
        content: '\f291';
        font-size:1.2rem;
        color: #fff;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(0);
        left: 2%;
      }
    }

    .news-head{
      position: relative;
      z-index:100;
      margin-top:-1rem;
    }
    .news-head-bg-line{
      position: absolute;
      bottom: 0;
      left: 0;
      background-repeat: no-repeat;
      height:70%;
      background: url("~assets/info_top_frame.png");
      background-size: 100% 100%;
      transform: translateY(0) translateX(0);
    }
    .news-head-bg-line-center{
      position: absolute;
      height:10px;
      left:50%;
      width: 7rem;
      top: 0;
      background-color: #fff;
      transform: translateY(0) translateX(-50%);
      border:none;
    }

    .btn-event{
      white-space:normal !important;
      word-wrap:break-word;
      width: 95%;
      @media(min-width: map-get($grid-breakpoints, "md")) {
        width: 80%;
      }
      @media(min-width: map-get($grid-breakpoints, "lg")) {
        width: 95%;
      }
      @media(max-width: map-get($grid-breakpoints, "xl") - 1) {
        font-size: .8rem;
      }
    }

    .now-public-event-list{
      .end-at{
        font-weight: bold;
        font-size:0.8rem;
      }
      .event-status{
        .event-status-mark{
        }
      }
    }
    .public-exit-event-list{
      .end-at{
        font-weight: bold;
        color: #9f9c9a;
        font-size:0.8rem;
      }
      .event-status{
        color: #9f9c9a;
        .event-status-mark{
        }
      }
      button{
        cursor: default;
      }
    }
  }




</style>



// WEBPACK FOOTER //
// PageContent.vue?fe75c832